<template>
  <div class="page">
    <div class="hero">
      <div>
        <div class="hello">欢迎回来，{{ home.user.nickname || '用户' }}</div>
        <div class="hero-sub">签约状态：<span class="pill ok" v-if="home.hasSigned">已签约</span><span class="pill" v-else>未签约</span></div>
        <div class="device-line">设备 SN：{{ device.sn || '未绑定' }} · <span :class="device.status === 'ONLINE' ? 'green' : 'gray'">{{ device.status === 'ONLINE' ? '在线' : '离线' }}</span><small v-if="lastRefresh"> · {{ lastRefresh }} 刷新</small></div>
        <div class="device-line">签约人：{{ home.hasSigned ? (home.signerName || home.user.nickname || '客户') : '未签约' }}</div>
        <div class="device-line">签约日期：{{ home.signDate || '未签约' }}</div>
        <div class="muted" v-if="device.offline_reason">离线原因：{{ device.offline_reason }}</div>
      </div>
      <button class="btn" @click="bind">机具绑定</button>
    </div>

    <div class="money-grid">
      <div class="metric"><div class="muted">签约总额</div><div class="money">¥{{ money(home.signedAmount || 0) }}</div></div>
      <div class="metric"><div class="muted">已达标</div><div class="money">{{ money(home.achievedAmount || 0) }}/{{ money(home.packageAmount || home.signedAmount || 780) }}</div><p>每月达标 +{{ oneDecimal(home.monthlyAmount || 32.5) }}</p></div>
      <div class="metric"><div class="muted">已提现</div><div class="money">¥{{ money(home.paid || 0) }}</div></div>
    </div>

    <div class="education-showcase">
      <div class="section-kicker">EDU BENEFIT</div>
      <div class="edu-title-row"><div><h2>{{ education.title || '九学王 · 正版同步课堂权益' }}</h2><p>正版 K12 同步教育资源，设备绑定成功即可免费使用。</p></div></div>
      <div class="story-grid">
        <div class="story-block story-img"><div class="edu-visual"><img src="/edu/jiuxuewang-company.webp" alt="九学王企业介绍"></div></div>
        <div class="story-block story-copy"><div class="edu-copy"><h3>课程内容提供方</h3><p><b>九学王教育</b></p><p>覆盖小学、初中、高中全学段及主流教材版本，提供课前预习、同步课堂、课后复习和考点巩固。</p><div class="cert-grid"><span>正版同步课程</span><span>全学段覆盖</span><span>多终端学习</span><span>持续内容更新</span></div></div></div>
        <div class="story-block story-img"><div class="edu-visual course-screen"><img src="/edu/jiuxuewang-courses.webp" alt="九学网同步课堂课程页面"></div></div>
        <div class="story-block story-copy"><div class="course-copy"><h3>同步课堂产品介绍</h3><p>课程贴合校内课标，满足学生课前预习、课后查漏补缺和假期知识巩固需求。</p><div class="tag-list"><span v-for="tag in educationTags" :key="tag">{{ tag }}</span></div></div></div>
      </div>
      <div v-if="education.content" class="admin-rich"><div class="rich-content" v-html="education.content"></div></div>
    </div>
  </div>
</template>
<script>
import { api, getUserId, ensureLogin } from '../api'
export default {
  data: () => ({ home: { user: {}, device: {} }, content: {}, lastRefresh: '', refreshTimer: null }),
  computed: {
    device () { return this.home.device || {} },
    education () { return this.content.education_benefit || {} },
    educationTags () { try { return JSON.parse(this.education.extra_json || '[]') } catch (e) { return [] } }
  },
  async created () {
    await this.loadContent()
    await this.load()
    if (this.device.sn) localStorage.setItem('deviceSn', this.device.sn)
    this.refreshTimer = setInterval(() => this.refreshStatus(false), 30000)
    document.addEventListener('visibilitychange', this.onVisible)
  },
  beforeDestroy () { clearInterval(this.refreshTimer); document.removeEventListener('visibilitychange', this.onVisible) },
  methods: {
    oneDecimal (v) { return Number(v || 0).toFixed(1) },
    async loadContent () { try { const rows = (await api.get('/h5/content-config')).data.data || []; rows.forEach(x => this.$set(this.content, x.config_key, x)) } catch (e) {} },
    async load () { try { this.home = (await api.get('/h5/home', { params: { userId: getUserId() } })).data.data || { user: {}, device: {} } } catch (e) { this.home = { user: {}, device: {} } } },
    async refreshStatus (showError) { try { const r = (await api.post('/h5/dashboard/refresh', {}, { params: { includeLedger: false } })).data.data || {}; this.lastRefresh = (r.refreshedAt || '').slice(11, 16); await this.load() } catch (e) { if (showError) alert('设备状态刷新失败') } },
    onVisible () { if (document.visibilityState === 'visible') this.refreshStatus(false) },
    money (v) { return Number(v || 0).toFixed(2).replace(/(\.\d)0$/, '$1').replace('.00', '') },
    async bind () { const uid = await ensureLogin(); if (uid) this.$router.push('/bind-device') }
  }
}
</script>
<style scoped></style>
